import API from './api';

export default class UserPasswordApi {
  static create(params) {
    return API.post('/advertisers/users/password', params);
  }

  static update(params) {
    return API.put('/advertisers/users/password', params);
  }
}
